import { InjectedFormProps, reduxForm } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React from 'react';
import { maxLength, required, Validators } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/substitution-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { asyncPersistSubstitution } from 'src/store/actions/substitution-actions';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { FieldDropdown } from '../../../../../components/redux-form/fields/FieldDropdown';
import { FieldDate } from '../../../../../components/redux-form/fields/FieldDate';
import SeanceProvidersGrid from './SeanceGridProviders';
import { Paginated } from '../../../../../services/api-handlers/pagination';
import { ISeance } from '../../../../../types/seance';

export interface SubstitutionFormData {
    id: string | number;
    substitutedProviderDropDown: SelectObject | undefined;
    providerDropDown: SelectObject | undefined;
    seanceDateFrom: string;
    seanceDateTo: string;

    seances: any;
}

interface SubstitutionFormProps {
    data: Paginated<ISeance>;
    providers: SelectObject[];
    provider: SelectObject | undefined;

    isFirst: boolean;
    inProgressSeance: boolean;
    stateData: any;
    setStateData: (data: any) => void;
    handleSub: (data: (e: any) => void, e: any) => void;
    findSeance: () => void;
}

type InjectedProps = InjectedFormProps<SubstitutionFormData, SubstitutionFormProps>;

const validators: Validators<SubstitutionFormData> = {
    substitutedProviderDropDown: [required({ message: 'Substituted Provider is required.' }), maxLength({ max: 255 })],
    providerDropDown: [required({ message: 'Substituted Provider is required.' }), maxLength({ max: 255 })],
    seanceDateFrom: [maxLength({ max: 255 })],
    seanceDateTo: [maxLength({ max: 255 })],
};

const SubstitutionForm: React.FunctionComponent<InjectedProps & SubstitutionFormProps> = ({
    handleSubmit,
    error,
    dirty,
    data,
    setStateData,
    stateData,
    submitting,
    providers,
    inProgressSeance,
    isFirst,
    handleSub,
    findSeance,
    initialValues,
}: InjectedProps & SubstitutionFormProps) => {
    const isNew = !initialValues || !initialValues.id;

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />

            <FieldDropdown
                name="providerDropDown"
                data={providers}
                textField={'label'}
                valueField={'value'}
                validate={validators.providerDropDown}
                wrapperConfig={{
                    label: 'Substituted Provider:',
                }}
            />
            <FieldDropdown
                name="substitutedProviderDropDown"
                data={providers}
                textField={'label'}
                valueField={'value'}
                validate={validators.substitutedProviderDropDown}
                wrapperConfig={{
                    label: 'Provider who substitutes:',
                }}
            />
            <div className={classNames(styles.wrap)}>
                <div className={classNames(styles.rowField)}>
                    <FieldDate
                        name="seanceDateFrom"
                        type="text"
                        date={true}
                        validate={validators.seanceDateFrom}
                        wrapperConfig={{
                            label: 'Date From:',
                        }}
                    />
                </div>
                <div className={classNames(styles.rowField)}>
                    <FieldDate
                        name="seanceDateTo"
                        type="text"
                        date={true}
                        validate={validators.seanceDateTo}
                        wrapperConfig={{
                            label: ' To  ',
                        }}
                    />
                </div>
                <button
                    type="button"
                    style={{ height: 36 }}
                    className={classNames('btn', 'btn-primary ml-4 mb-2')}
                    onClick={() => {
                        findSeance();
                    }}
                >
                    Find Sessions
                </button>
            </div>
            {isFirst ? (
                <div className={'list'}>
                    <h2 className={`${classNames('pageHeadingTitle')}`}>SUBSTITUTIONS</h2>
                    <SeanceProvidersGrid
                        inProgressSeance={inProgressSeance}
                        stateData={stateData}
                        setStateData={setStateData}
                        data={data}
                    />
                </div>
            ) : null}
            <div className={classNames(styles.actions)}>
                <button
                    type="button"
                    onClick={(e) => {
                        handleSub(handleSubmit, e);
                    }}
                    className={classNames('btn', 'btn-success', 'mr-3')}
                    disabled={!dirty || submitting || !isFirst}
                >
                    <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                </button>
                <Link className={classNames('btn', 'btn-danger')} to={Router.generate(routes.SUBSTITUTIONS_LIST)}>
                    <FontAwesomeIcon icon={faBan} /> Cancel
                </Link>
            </div>
        </form>
    );
};

export default reduxForm<SubstitutionFormData, SubstitutionFormProps>({
    form: 'substitution-form',
    onSubmit: async (data: SubstitutionFormData, dispatch: Dispatch<any>, props: SubstitutionFormProps) => {
        await asyncPersistSubstitution(
            { ...data, seances: props.stateData },
            //props.files,
            dispatch,
        );
    },
    onSubmitSuccess() {
        toast.success('add substitution success.');
    },

    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(SubstitutionForm);
